import { Link } from "react-router-dom";

const Sidebar = () => {
  return (
    <div className="h-screen bg-gray-800 text-white shadow-lg w-64 p-4 flex flex-col">
      <nav className="flex flex-col gap-4">
        <Link to="/admin/dashboard" className="text-white hover:text-blue-600">Dashboard</Link>
        <Link to="/admin/users" className="text-white hover:text-blue-600">Kullanıcılar</Link>
        <Link to="/admin/products" className="text-white hover:text-blue-600">Ürünler</Link>
        <Link to="/admin/campaigns" className="text-white hover:text-blue-600">Kampanyalar</Link>
        <Link to="/admin/orders" className="text-white hover:text-blue-600">Siparişler</Link>
      </nav>
    </div>
  );
};

export default Sidebar;
